import { action, computed, observable } from 'mobx';
import { Artifact } from '../_interfaces/Artifact';
import { Collection } from '../_interfaces/Collection';

export class SearchBarFilterStore {
    @observable private _searchTerms: Array<string> = [];
    @observable private _artifactsForSearchParameters: Array<Artifact> = [];
    @observable private _isSearching = false;
    @observable private _searchingInsideCollection: Collection | undefined;

    @computed
    get isSearching(): boolean {
        return this._isSearching;
    }
    @computed
    public get searchTerms(): Array<string> {
        return this._searchTerms;
    }

    @computed
    public get artifactsForSearchParamaters(): Array<Artifact> {
        return this._artifactsForSearchParameters;
    }

    @computed
    public get searchingInsideCollection(): Collection | undefined {
        return this._searchingInsideCollection;
    }

    @action
    public setCurrentCollection(collection: Collection | undefined): void {
        this._searchingInsideCollection = collection;
    }

    @action
    public addSearchTerm(text: string): void {
        text.split(',').forEach((str) => {
            if (str !== '') {
                this._searchTerms.push(str.trim());
            }
        });

        this._isSearching = true;
    }

    @action
    public setIsSearching(isSearching: boolean): void {
        this._isSearching = isSearching;
    }

    @action
    public removeAllSearchTerms(): void {
        this._searchTerms = [];
        this._isSearching = false;
        this._searchingInsideCollection = undefined;
    }

    public removeSearchTerm(index: number): void {
        const searchTerms = [...this._searchTerms];
        searchTerms.splice(index, 1);
        this._searchTerms = searchTerms;
    }
}



// WEBPACK FOOTER //
// ./src/_stores/SearchBarFilterStore.ts